import { GuardianRegistry } from "@/features/guardian-registry";

export function GuardianRegistryPage() {
  return <GuardianRegistry />;
}
